(function () {
    'use strict';

    angular
        .module('app')
        .factory('EntityFieldArray', EntityFieldArrayFactory);

    EntityFieldArrayFactory.$inject = ['EntityFieldScalar'];

    function EntityFieldArrayFactory(EntityFieldScalar) {

        /**
         * @constructor
         * @name EntityFieldArray
         */
        function EntityFieldArray(name) {
            EntityFieldScalar.call(this, name, []);

            this.fieldInfo = {
                mandatory: false
            };
        }

        EntityFieldArray.prototype = Object.create(EntityFieldScalar.prototype);
        EntityFieldArray.prototype.constructor = EntityFieldArray;

        EntityFieldArray.prototype.toString = function () {
            return Array.prototype.toString.call(this.value);
        };

        return EntityFieldArray;
    }
})();